import { createSelector } from '@ngrx/store';
import { selectAllExternalActionEntities } from '../generated/external-action-record.generated';
import { selectAllExternalActionTypeEntities } from '../generated/external-action-type-record.generated';

export function selectNextExternalActionInQueueByCardId(cardId: string) {
  return createSelector(
    selectPendingExternalActionsByEntityId(cardId),
    selectAllExternalActionTypeEntities,
    (actions, types) => {
      return (
        actions
          .map((a) => {
            const type = types.get(a.actionTypeId);
            return { externalAction: a, externalActionType: type };
          })
          .filter((i) => i.externalActionType != null)
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          .sort((a, b) => a.externalActionType!.priority - b.externalActionType!.priority)
          .map((i) => i.externalAction)
          .first(undefined)
      );
    },
  );
}

export function selectAllPendingExternalActions() {
  return createSelector(selectAllExternalActionEntities, (actions) =>
    actions.filter((a) => a.dateCompleted == null),
  );
}

export function selectPendingExternalActionsByEntityId(entityId: string) {
  return createSelector(selectAllPendingExternalActions(), (actions) =>
    actions.filter((a) => a.entityId === entityId),
  );
}

export function selectPendingExternalActionByEntityIdAndTypeId(entityId: string, typeId: string) {
  return createSelector(selectAllPendingExternalActions(), (actions) =>
    actions.find((a) => a.entityId === entityId && a.actionTypeId === typeId),
  );
}
